import React, { useState } from "react";
import { REFUND_OPTIONS } from "~/constants";
import styles from "./RefundOptions.module.scss";
import classnames from "classnames";
import getServerSideProps from "~/app/getServerSideProps";
import { RoundCheckbox } from "~/components/inputs/RoundCheckbox";
import { isBrandFrameBackgroundSolidWhite } from "~/cores/brandDataCore";
import { getFilteredRefundOptions, getSelectedRefundOption, getSelectedRefundOptionObject } from "~/cores/appCore";
import { ExternalLink } from "~/components/links/ExternalLink";
import { ProductItemWrapperOnly } from "~/components/productItem/ProductItem";
import { ProductFlexItemWrapper } from "~/components/productItem/ProductsFlexWrapper";
import { getRefundOptionHeader } from "~/cores/refundCore";

const RefundOptions = function (props) {
    let { appProps, system, selectedRefundOption, setSelectedRefundOption } = props;
    const getLocaleText = system.getLocaleText;
    const [showChangeSelections, setShowChangeSelections] = useState(false);

    const refundOptions = getFilteredRefundOptions(appProps);

    function getRefundTitle(refundOption) {
        return getRefundOptionHeader(refundOption, { appProps });
    }

    if (!refundOptions || refundOptions?.length === 0 || !getSelectedRefundOption(appProps)) {
        return null;
    }

    const selectedRefundOptionObject = getSelectedRefundOptionObject(appProps);

    const onlyOneRefundOption = refundOptions?.length === 1;

    return (
        <ProductFlexItemWrapper newRow={true}>
            {!showChangeSelections && !onlyOneRefundOption && (
                <ProductItemWrapperOnly
                    style={{
                        justifyContent: "space-between",
                        width: "100%",
                    }}
                >
                    <div
                        style={{
                            padding: "6px 20px",
                            display: "flex",
                            width: "100%",
                            justifyContent: "space-between",
                        }}
                    >
                        {getRefundTitle(selectedRefundOptionObject)}
                        <ExternalLink style={{ cursor: "pointer" }} onClick={() => setShowChangeSelections(!showChangeSelections)} text={getLocaleText("change")}></ExternalLink>
                    </div>
                </ProductItemWrapperOnly>
            )}
            <div
                style={{
                    visibility: !showChangeSelections && "hidden",
                    height: !showChangeSelections && 0,
                }}
            >
                <ProductItemWrapperOnly>
                    <section className={classnames(styles["refund-options"], !isBrandFrameBackgroundSolidWhite(appProps) && styles["refund-options-brand-opacity"])}>
                        {refundOptions.map((o, i) => {
                            return (
                                <React.Fragment key={o.type}>
                                    <RoundCheckbox
                                        className={styles["refund-option-checkbox"]}
                                        checked={selectedRefundOption === o.type}
                                        onChange={
                                            !onlyOneRefundOption &&
                                            (() => {
                                                setSelectedRefundOption(o.type);
                                            })
                                        }
                                    >
                                        <div className={classnames(styles["refund-option"])}>
                                            <div className={styles["refund-option-title-wrapper"]}>
                                                <div className={styles["refund-option-title"]}>{getRefundTitle(o)}</div>
                                                <div className={styles["refund-options-subtitle"]}>{getLocaleText(["confirmation-page.refund-options", o.type, "text"])}</div>
                                            </div>
                                            {o.type === REFUND_OPTIONS.GIFT_CARD && (
                                                <div className={styles["best-value"]}>
                                                    {getLocaleText(["confirmation-page.refund-options", o.type, "best-value"], null, {
                                                        styles: {
                                                            whiteSpace: "nowrap",
                                                        },
                                                    })}
                                                    {/*<FontAwesomeIcon width={"20px"} icon={faThumbsUp} />*/}
                                                </div>
                                            )}
                                        </div>
                                    </RoundCheckbox>

                                    {i !== refundOptions.length - 1 && <div className={styles["refund-option-divider"]} />}
                                </React.Fragment>
                            );
                        })}
                    </section>
                </ProductItemWrapperOnly>
            </div>
        </ProductFlexItemWrapper>
    );
};

export { getServerSideProps };
export default RefundOptions;
